import {
  Plus, BarChart3 
} from 'lucide-react';
import type { WasteReason } from '@/features/waste';

export const DEFAULT_SITE_ID = 'site-celebration';

export const TABS = [
  {
    id: 'log',
    label: 'Log Waste',
    href: '/waste/log',
    icon: Plus 
  },
  {
    id: 'reports',
    label: 'Reports',
    href: '/waste/reports',
    icon: BarChart3 
  },
] as const;

export type TabId = 'log' | 'reports';

export const REASON_TABS: {
  value: WasteReason | undefined;
  label: string 
}[] = [
  {
    value: undefined,
    label: 'All' 
  },
  {
    value: 'spoilage',
    label: 'Spoilage' 
  },
  {
    value: 'overproduction',
    label: 'Overproduction' 
  },
  {
    value: 'prep-waste',
    label: 'Prep Waste' 
  },
  {
    value: 'plate-waste',
    label: 'Plate Waste' 
  },
  {
    value: 'expired',
    label: 'Expired' 
  },
  {
    value: 'quality-issue',
    label: 'Quality Issue' 
  },
];

export const MOCK_VENUES = [
  {
    id: 'venue-main-dining',
    name: 'Main Dining Room' 
  },
  {
    id: 'venue-buffet',
    name: 'Deck 9 Buffet' 
  },
  {
    id: 'venue-pool-bar',
    name: 'Pool Bar' 
  },
  {
    id: 'venue-specialty',
    name: 'Specialty Restaurant' 
  },
];

export const MOCK_ITEMS = [
  {
    id: 'item-001',
    name: 'Atlantic Salmon Fillet',
    unit: 'kg',
    costPerUnit: 18.5 
  },
  {
    id: 'item-003',
    name: 'Lobster Tail 8oz',
    unit: 'each',
    costPerUnit: 24.0 
  },
  {
    id: 'item-004',
    name: 'USDA Prime Ribeye',
    unit: 'kg',
    costPerUnit: 45.0 
  },
  {
    id: 'item-009',
    name: 'Fresh Basil',
    unit: 'kg',
    costPerUnit: 17.0 
  },
  {
    id: 'item-010',
    name: 'Roma Tomatoes',
    unit: 'kg',
    costPerUnit: 3.5 
  },
  {
    id: 'item-012',
    name: 'Arborio Rice',
    unit: 'kg',
    costPerUnit: 3.0 
  },
];
